<template>
  <div class="body-container border-container">
    <div class="select-scroll">
      <!-- <TelehealthBanner /> -->
      <div class="learn-container">
        <div id="main">
          <div id="faq">
            <div v-if="!showDetail">
              <div class="learntab-study-logo p-12 pb-30">
                <img width="50px" :src="studyLogoUrl" />
              </div>
              <div class="card learn-card" v-for="(data, index) in sections" :key="index">
                <div class="card-header" :id="index">
                  <a v-if="data.type !== 'feedback'" @click="goToLearn(data.id)" class="btn btn-header-link d-flex align-items-center">
                    <div
                      class="mr-15 learn_icon"
                      :style="{
                        '--bg-image': 'url(' + bitrise.getIcon(data.sectionIcon) + ')'
                      }"
                      alt="chevron-right"
                    ></div>
                    <span
                      v-translate:dynamic_string="{
                        key: `${data.id}_sectionTitle`,
                        val: lang,
                        html: data.sectionTitle
                      }"
                      >{{ data.sectionTitle }}</span
                    >
                    <span class="float-right ml-auto">
                      <img src="static/img/participant-portal/forward_arrow.svg" alt="chevron-right" />
                    </span>
                  </a>
                  <a v-else @click="goToFeedback()" class="btn btn-header-link d-flex align-items-center">
                    <div
                      v-if="bitrise.getImage(data.sectionIcon)"
                      class="mr-15 learn_icon"
                      :style="{
                        '--bg-image': 'url(' + bitrise.getImage(data.sectionIcon) + ')'
                      }"
                      @error="imageLoadOnError()"
                      alt="feedback"
                    ></div>
                    <div v-else class="mr-15 learn_icon" :style="{ '--bg-image': 'url(' + appIcon + ')' }" alt="feedback1"></div>
                    <span
                      v-translate:dynamic_string="{
                        key: `${studyId}_FEEDBACK_sectionTitle`,
                        val: lang,
                        html: feedbackTitle
                      }"
                      >{{ feedbackTitle }}</span
                    >
                    <span class="float-right ml-auto">
                      <img src="static/img/participant-portal/forward_arrow.svg" alt="chevron-right" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div v-else>
              <detail v-if="isDetail" :data="learnDetail" @back="getLearnList"></detail>
              <feedback v-if="isFeedback" :data="learnDetail" @back="getLearnList"></feedback>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Bitrise, Widget } from "@/components/services/participant-service";
import nprogress from "nprogress";
import detail from "@/components/participant-portal/learn/details";
import feedback from "@/components/participant-portal/learn/feedback";
import appIcon from "@/assets/app_icon.png";
export default {
  name: "learn",
  data() {
    return {
      widget: new Widget(),
      bitrise: new Bitrise(),
      allScreens: [],
      assets: [],
      sections: [],
      isDetail: false,
      isFeedback: false,
      feedbacks: {},
      showDetail: false,
      learnDetail: {},
      isImgFail: false,
      appIcon: appIcon
    };
  },
  props: ["studyId", "globalElement"],
  computed: {
    ...mapGetters(["participant", "token", "getParticipantsPortalGlobalElements"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    studyLogoUrl() {
      return this.getParticipantsPortalGlobalElements ? this.getParticipantsPortalGlobalElements.studyLogoUrl : "";
    },
    feedbackTitle() {
      return this.widget.i18nActivities(`${this.studyId}_LEARN_FEEDBACK_title`, this.lang) ? this.widget.i18nActivities(`${this.studyId}_LEARN_FEEDBACK_title`, this.lang) : this.widget.i18nActivities("FEEDBACK_sectionTitle", this.lang) ? this.widget.i18nActivities("FEEDBACK_sectionTitle", this.lang) : this.feedbacks.title;
    }
  },
  components: {
    detail,
    feedback
  },
  mounted() {
    nprogress.start();
    this.getSectionContent();
  },
  methods: {
    imageLoadOnError() {
      this.isImgFail = true;
    },
    getSectionContent() {
      this.$api
        .getLearnMoreData(this.studyId, this.participant.myStudyVersionId)
        .then(response => {
          this.bitrise.updateHTMLData(response.data);
          this.getLearnData();
        })
        .catch(error => {
          const message = this.widget.translate(error.message, "Data sync failed, please try again after some time.");
          if (message) {
            this.$toastr.error(message);
          }
          nprogress.done();
        });
    },
    getLearnData() {
      const learnDataObj = this.bitrise.getJsonData("learn_more");
      if (learnDataObj) {
        learnDataObj
          .then(response => {
            this.sections = response.sections;
            this.feedbacks = response.feedback;
            nprogress.done();
          })
          .catch(error => {
            const message = this.widget.translate(error.message, this.lang);
            if (message) {
              this.$toastr.error(message);
            }
            nprogress.done();
          });
      }
    },
    goToLearn(id) {
      if (this.sections.length) {
        this.sections.forEach(element => {
          if (element.id == id) {
            this.learnDetail = element;
          }
        });
        this.showDetail = true;
        this.isDetail = true;
        this.isFeedback = false;
      }
    },
    goToFeedback() {
      if (this.feedbacks) {
        this.learnDetail = this.feedbacks;
        this.showDetail = true;
        this.isFeedback = true;
        this.isDetail = false;
      }
    },
    getLearnList() {
      this.showDetail = false;
    }
  }
};
</script>

<style scoped>
.card {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}
.learn_icon {
  width: 20px;
  height: 26px;
  background: var(--secondary);
  -webkit-mask: var(--bg-image) center/contain;
  mask: var(--bg-image) center/contain;
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}
.select-scroll {
  height: 600px;
  overflow-y: auto;
}
.learntab-study-logo img {
  display: block;
  margin: auto;
}
</style>
